// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"044dd241","188":"41171f79","301":"664a275f","444":"f1a9f9ab","682":"27e8ba0c","807":"41171f79"}[chunkId] + ".chunk.js";
};